import React from "react";
import {
  FiAlertCircle,
  FiBookOpen,
  FiClock,
  FiCompass,
  FiHeart,
  FiLock,
  FiMessageCircle,
  FiMoon,
  FiShoppingCart,
  FiSun,
  FiTarget,
  FiThermometer,
  FiZap,
} from "react-icons/fi";

// Secciones "próximamente": Psicólogo IA (de pago) y Cocinero IA.
const VERDE = "linear-gradient(90deg, #7CF58A, #4CAF6A)";

function Pagina({ etiqueta, titulo, texto, Icono, beneficios, pasos, nota, aviso }) {
  return (
    <div style={{ maxWidth: 760 }}>
      <section
        style={{
          background: "#101513",
          color: "#F5F7F5",
          borderRadius: 28,
          padding: "28px 24px",
          marginBottom: 20,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          aria-hidden="true"
          style={{ position: "absolute", right: -40, top: -40, width: 180, height: 180, borderRadius: "50%", background: "rgba(124,245,138,.12)" }}
        />
        <span
          style={{
            display: "inline-block",
            background: VERDE,
            color: "#101513",
            fontWeight: 700,
            fontSize: 13,
            padding: "6px 12px",
            borderRadius: 999,
            marginBottom: 16,
          }}
        >
          {etiqueta}
        </span>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 10 }}>
          <span
            aria-hidden="true"
            style={{ display: "grid", placeItems: "center", width: 48, height: 48, borderRadius: 16, background: "rgba(124,245,138,.15)", color: "#7CF58A", fontSize: 24 }}
          >
            <Icono />
          </span>
          <h2 style={{ margin: 0, fontSize: 28, lineHeight: 1.15 }}>{titulo}</h2>
        </div>
        <p style={{ margin: 0, opacity: 0.8, fontSize: 16, lineHeight: 1.5 }}>{texto}</p>
      </section>

      <h3 style={{ margin: "0 0 12px", fontSize: 18 }}>Qué te va a aportar</h3>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 12, marginBottom: 24 }}>
        {beneficios.map(({ Icono: I, titulo: t, texto: x }) => (
          <div key={t} className="app-panel" style={{ padding: 16 }}>
            <I aria-hidden="true" style={{ fontSize: 20, color: "#4CAF6A" }} />
            <strong style={{ display: "block", margin: "8px 0 4px" }}>{t}</strong>
            <span style={{ opacity: 0.75, fontSize: 14, lineHeight: 1.45 }}>{x}</span>
          </div>
        ))}
      </div>

      <h3 style={{ margin: "0 0 12px", fontSize: 18 }}>Cómo funcionará</h3>
      <ol style={{ listStyle: "none", padding: 0, margin: "0 0 24px" }}>
        {pasos.map((p, i) => (
          <li key={p} style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 10 }}>
            <span
              style={{ flex: "0 0 32px", height: 32, borderRadius: "50%", background: VERDE, color: "#101513", fontWeight: 700, display: "grid", placeItems: "center" }}
            >
              {i + 1}
            </span>
            <span>{p}</span>
          </li>
        ))}
      </ol>

      <div className="app-panel" style={{ padding: 16, marginBottom: 16, textAlign: "center" }}>
        {nota && <p style={{ margin: "0 0 12px", fontWeight: 600 }}>{nota}</p>}
        <button type="button" className="app-btn" disabled style={{ opacity: 0.6, cursor: "not-allowed" }}>
          Disponible muy pronto
        </button>
        <p style={{ margin: "12px 0 0", fontSize: 14, opacity: 0.7 }}>
          ¿Te interesa? Díselo a tu entrenador por Mensajes y te avisamos en cuanto esté.
        </p>
      </div>

      {aviso && (
        <p style={{ display: "flex", gap: 8, fontSize: 13, opacity: 0.8, lineHeight: 1.5 }}>
          <FiAlertCircle aria-hidden="true" style={{ flex: "0 0 auto", marginTop: 3 }} />
          <span>{aviso}</span>
        </p>
      )}
    </div>
  );
}

export function PsicologoIA() {
  return (
    <Pagina
      etiqueta="Próximamente · Servicio de pago"
      titulo="Tu psicólogo IA"
      Icono={FiHeart}
      texto="Un espacio para cuidar tu cabeza igual que cuidas tu cuerpo. Habla cuando lo necesites, sin esperas y sin juicios."
      beneficios={[
        { Icono: FiClock, titulo: "Disponible 24 horas", texto: "De madrugada, antes de entrenar o después de un mal día. Siempre hay alguien al otro lado." },
        { Icono: FiSun, titulo: "Estrés y ansiedad", texto: "Técnicas sencillas para calmarte y ordenar lo que te preocupa." },
        { Icono: FiZap, titulo: "Motivación y constancia", texto: "Te ayuda a retomar cuando te cuesta y a no abandonar a las dos semanas." },
        { Icono: FiTarget, titulo: "Tu relación con la comida", texto: "Para trabajar la ansiedad por comer y la culpa, a tu ritmo." },
        { Icono: FiMoon, titulo: "Descanso", texto: "Rutinas para desconectar y dormir mejor, que también es parte del progreso." },
        { Icono: FiLock, titulo: "Sin juicios", texto: "Cuenta lo que te pasa con tus palabras, sin miedo a qué pensarán." },
      ]}
      pasos={[
        "Activas el servicio desde la app (suscripción mensual).",
        "Le cuentas cómo estás o qué te preocupa.",
        "Te propone ejercicios prácticos y hace seguimiento contigo.",
      ]}
      nota="Servicio de pago · precio por anunciar"
      aviso="El psicólogo IA es un apoyo y no sustituye a un profesional de la salud mental. Si estás pasando por un momento muy difícil o piensas en hacerte daño, llama al 024 (gratuito y 24 horas) o al 112 si es una emergencia."
    />
  );
}

export function CocineroIA() {
  return (
    <Pagina
      etiqueta="Próximamente"
      titulo="Tu cocinero IA"
      Icono={FiThermometer}
      texto="Elige qué te apetece cocinar y te guía paso a paso, como si tuvieras un chef a tu lado en la cocina."
      beneficios={[
        { Icono: FiCompass, titulo: "Paso a paso", texto: "Cada paso explicado, con tiempos y temporizadores para que no se te pase nada." },
        { Icono: FiTarget, titulo: "Adaptado a tu plan", texto: "Raciones y calorías ajustadas a tu objetivo, igual que tu plan de comidas." },
        { Icono: FiShoppingCart, titulo: "Con lo que tienes", texto: "Dile qué hay en tu nevera y te propone qué cocinar con eso." },
        { Icono: FiMessageCircle, titulo: "Dudas al momento", texto: "¿Puedo cambiar la nata por yogur? Pregunta mientras cocinas y te responde." },
        { Icono: FiBookOpen, titulo: "Para todos los niveles", texto: "Desde lo más básico hasta platos que nunca te habías atrevido a hacer." },
        { Icono: FiSun, titulo: "Cocina de todo el mundo", texto: "Elige el tipo de comida que te apetezca y aprende a hacerla bien." },
      ]}
      pasos={[
        "Le dices qué quieres cocinar o qué tienes en casa.",
        "Te prepara los ingredientes y las cantidades para ti.",
        "Te guía paso a paso hasta que el plato está listo.",
      ]}
    />
  );
}
